import { accessTokenInterceptor } from '@teko/auth';
import Api from '@teko/api';

const normalizeData = (responseAddresses) => {
    return responseAddresses.map((addr) => (Object.assign(Object.assign({}, addr), { addressId: addr.id })));
};
class UserService {
    constructor(userServiceUrl, platformCode, platformId) {
        this.userApi = null;
        this.platformCode = null;
        this.myProfile = async (params = {}) => {
            var _a;
            const { data } = await this.userApi.get('/profiles', {
                params: Object.assign({ platformCode: this.platformCode }, params),
            });
            return (_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.profile;
        };
        this.updateProfile = async (body) => {
            var _a;
            const { data } = await this.userApi.patch('/profiles', body, {
                params: { platformCode: this.platformCode },
            });
            return (_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.profile;
        };
        this.updateBillings = async (body) => {
            const { data } = await this.userApi.post('/billings', body, {
                params: { platformCode: this.platformCode },
            });
            return data;
        };
        this.getReview = async (params) => {
            const { data } = await this.userApi.get('/ratings', { params });
            return data;
        };
        this.getMyAddresses = async () => {
            const { data: { result: { addresses }, }, } = await this.userApi.get('/addresses', {
                params: { platformCode: this.platformCode },
                headers: { 'Content-Type': undefined },
            });
            return normalizeData(addresses);
        };
        this.createAddress = async (address) => {
            const { data: { result: { address: addressResp }, }, } = await this.userApi.post('/addresses', address);
            return addressResp;
        };
        this.updateAddress = async (addressId, address) => {
            await this.userApi.patch(`/addresses/${addressId}`, address);
        };
        this.getAddress = async (addressId) => {
            const { data: { result: { address }, }, } = await this.userApi.get(`/addresses/${addressId}`);
            return address;
        };
        this.deleteAddress = async (addressId) => {
            const { data } = await this.userApi.delete(`/addresses/${addressId}`);
            return data;
        };
        this.viewPoint = async () => {
            return await this.userApi.get('/loyalty/viewpoint', {
                params: { platformCode: this.platformCode },
            });
        };
        this.registerLoyaltyMember = async (data) => {
            return await this.userApi.post('/loyalty/members', data, {
                params: { platformCode: this.platformCode },
            });
        };
        this.getRefCodeInfo = async (refCode) => {
            return this.userApi
                .get(`/dealer_farmer/ref/${refCode}`)
                .then((res) => res.data);
        };
        this.confirmFarmer = async (refCode) => {
            return this.userApi.post('/dealer_farmer/confirm', {
                referenceCode: refCode,
            });
        };
        this.upsertProfile = async (profileUpsertObject) => {
            const { data } = await this.userApi.post('/profiles/upsert', profileUpsertObject, {
                params: { platformCode: this.platformCode },
            });
            return data;
        };
        this.searchProfile = async (params = {}) => {
            const { data } = await this.userApi.get('/profiles/search', {
                params: Object.assign({ platformCode: this.platformCode }, params),
            });
            return data === null || data === void 0 ? void 0 : data.data;
        };
        this.customerTypes = async (params = {}) => {
            const { data } = await this.userApi.get('/customer-types', {
                params: Object.assign({ platformId: this.platformId }, params),
            });
            return data;
        };
        this.userApi = new Api(userServiceUrl);
        this.platformCode = platformCode;
        this.platformId = platformId;
        this.userApi.addInterceptor(accessTokenInterceptor);
    }
}

export { UserService };
